export default __webpack_public_path__ + "static/media/Akivneteh.5f87ce43.jpg";